export const reuniteConfigSchema = {
    type: 'object',
    properties: {
        ignoreLint: {
            oneOf: [
                { type: 'boolean', default: false },
                {
                    type: 'object',
                    additionalProperties: { type: 'boolean' },
                },
            ],
        },
        ignoreLinkChecker: { type: 'boolean' },
        ignoreMarkdocErrors: { type: 'boolean' },
    },
    additionalProperties: false,
};
//# sourceMappingURL=reunite-config-schema.js.map